import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'

import submit from './submit.js'
import Input from '../../Form/Field/Input.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'

export const name = 'LoginForm'

class LoginForm extends PureComponent {
  render() {
    return (
      <div id={name}>
        <form onSubmit={this.props.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
          <Field
            label="Email"
            name="email"
            component={Input}
            type="text"
            placeholder="john@doe.fr" />
          <Field
            label="Mot de passe"
            placeholder="Mot de passe"
            name="password"
            component={Input}
            type="password" />
          <input type="submit" className="d-none" />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  onSubmit: submit,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(LoginForm)